<script setup lang="ts">
const benefits = [
  {
    title: 'Lacak Paket Real Time',
    description:
      'Pantau posisi driver secara akurat untuk memastikan paketmu sampai dengan aman.',
    icon: 'material-symbols:travel-explore',
    iconSize: '33px'
  },
  {
    title: 'Tiba Hitungan Jam',
    description:
      'Produk sampai ke tangan pelanggan dalam waktu singkat, tanpa menunggu lama.',
    icon: 'svg-spinners:clock',
    iconSize: '33px'
  },
  {
    title: 'Kirim ke Banyak Tujuan',
    description:
      'Kirim paket ke hingga 5 tujuan dalam satu rute perjalanan untuk ekspedisi tertentu.',
    icon: 'material-symbols:pin-drop-outline',
    iconSize: '33px'
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <h2
        class="text-2xl leading-7 lg:text-4xl font-bold lg:text-center text-on-secondary-container font-display"
      >
        Keunggulan Kirim Paket Instant di KiriminAja
      </h2>
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>

      <CtaBase title="Coba Pengiriman Instant di KiriminAja Sekarang!" />
    </UiContainer>
  </section>
</template>
